import echarts from 'echarts';
import fa from 'element-ui/src/locale/lang/fa';
import { config } from '@/views/home/chartJs/chartCommon';
import Decimal from 'decimal.js'

export default function drawBar(params) {
  let { fontColor, fontSize, barColor, barColorOpacity, barLineBasicColor, tooltip, xAxis, legend } = config;
  let dimensions = [];
  for (let i in params.data[0]) {
    dimensions.push(i);
  }
  let series = [];
  let barC = barColor,
    barCO = barColorOpacity;
  if (params.barColor && params.barColorOpacity) {
    barC = params.barColor;
    barCO = params.barColorOpacity;
  }
  params?.names.forEach((item, i) => {
    series.push({
      type: 'bar',
      name: item,
      barWidth: 7,
      // barGap: 0,//柱间距离
      label: {
        show: params.showLabel,
        position: 'top',
        color: fontColor,
        fontSize: 10,
        fontFamily: 'Geometr706 BlkCn BT',
        normal: {
          show: false,
          /*
          *处理横坐标负半轴这边的  "柱状"  显示的数
          *后台传过来是数组过大进行计算
           */
          // formatter: function (value) {
          //   const num1 = new Decimal(10000);
          //   if (value.value[value.seriesName]) {
          //     const num2 = new Decimal(value.value[value.seriesName]);
          //     const resultValue = num2.dividedBy(num1).toNumber().toFixed(2);
          //     return resultValue
          //   } else {
          //     return value.value[value.seriesName]
          //   }
          // },
        }
      },
      itemStyle: {
        normal: {
          show: true,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0.4,
              color: barC[i],
            },
            {
              offset: 0.9,
              color: barCO[i],
            },
          ]),
          borderWidth: 1,
          borderColor: barC[i],
        },
      },
    });
    if (params.isStack) {
      series[i].stack = 'com';
    }
  });
  let axisLabel =  {
    color: fontColor,
    rotate: 45, // 设置文字旋转角度，单位为度，这里设置为45度，可根据实际需求调整
    textStyle: {
      fontSize: 10,
    },
    interval: 0,
  }
  let newXAxis = JSON.parse(JSON.stringify(xAxis))
  newXAxis[0].axisLabel = axisLabel
  let option = {
    dataset: {
      dimensions,
      source: params.data,
    },
    // backgroundColor: '#091C3D',
    tooltip,
    grid: {
      left: 0,
      top: '20%',
      right: 2,
      bottom: 0,
      containLabel: true,
    },
    legend: {
      //图例组件，颜色和名字
      ...legend,
      show: series.length > 1 ? true : false,
    },
    xAxis: newXAxis,
    yAxis: [
      {
        ...config.yAxis[0],
        name: params.yAxis.name,
        nameGap: 10,
        axisLabel: {
          // formatter: function (value) {
          //   if (value){
          //     const num1 = new Decimal(10000);
          //     const num2 = new Decimal(value);
          //     const resultValue = num2.dividedBy(num1).toNumber().toFixed(2);
          //     return resultValue
          //   } else {
          //     return value
          //   }
          // },
          textStyle: {
            color: fontColor,
            fontSize,
          },
        },
      },
    ],
    series,
  };
  return option;
}
